import { AirtableService } from '@/services/airtable.service';
import { format } from 'date-fns';
export default {
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      viewAirtable: false,
      isButtonDisabled: false
    };
  },
  mounted() {
    if (this.index === 0) {
      this.viewAirtable = true;
    }
  },
  methods: {
    parseDate(date, dateFormat) {
      if (date) {
        return format(new Date(date), dateFormat);
      }
    },
    async onAddressRemove() {
      try {
        const newOrder = await AirtableService.removeAddress(this.order['Prescription ID']);
        this.$emit('update:order', newOrder);
      } catch (e) {
        console.error(e);
      }
    },
    async onShippingRemove() {
      try {
        const newOrder = await AirtableService.removeShipping(this.order['Prescription ID']);
        this.$emit('update:order', newOrder);
      } catch (e) {
        console.error(e);
      }
    },
    async onHoldOrder() {
      try {
        this.isButtonDisabled = true;
        const newOrder = await AirtableService.holdOrder(this.order['Prescription ID']);
        this.$emit('update:order', newOrder);
        this.isButtonDisabled = false;
      } catch (e) {
        console.error(e);
      }
    },
    async onLiftOrder() {
      try {
        this.isButtonDisabled = true;
        const newOrder = await AirtableService.liftOrder(this.order['Prescription ID']);
        this.$emit('update:order', newOrder);
        this.isButtonDisabled = false;
      } catch (e) {
        console.error(e);
      }
    }
  }
};